import { cn } from "../lib/utils";

interface DotLoaderProps {
	dotClassName?: string;
}

export function DotLoader({
	dotClassName,
}: DotLoaderProps): React.ReactElement {
	return (
		<div className="flex h-full w-full items-center justify-center gap-xs">
			{[
				...new Array(3).fill(0).map((_, i) => (
					<div
						className={cn(
							"h-min w-min rounded-full",
							"flex-shrink-0 flex-grow-0",
							"animate-customBounce",
							dotClassName,
						)}
						key={`loader-${i * 2}`}
						style={{
							animationDelay: `${i * 0.2}s`,
							animationIterationCount: "infinite",
						}}
					/>
				)),
			]}
		</div>
	);
}
